export default function refreshAsync() {
  window.setTimeout(() => window.location.reload(), 50);
}
